import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Spinner,
  Nav,
  Tab,
} from "react-bootstrap";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

import { API_URL } from "../utils/config";
const CodeAssignmentFragment = () => {
  const [activeTab, setActiveTab] = useState("state");
  const [isLoading, setIsLoading] = useState(false);

  // State for state codes
  const [states, setStates] = useState([]);
  const [stateFormData, setStateFormData] = useState({
    name: "",
    code: "",
  });
  const [isEditingState, setIsEditingState] = useState(false);

  // State for city codes
  const [cities, setCities] = useState([]);
  const [cityFormData, setCityFormData] = useState({
    name: "",
    state: "",
    code: "",
  });
  const [isEditingCity, setIsEditingCity] = useState(false);

  // State for school codes
  const [schools, setSchools] = useState([]);
  const [schoolFormData, setSchoolFormData] = useState({
    name: "",
    state: "",
    city: "",
    code: "",
  });
  const [isEditingSchool, setIsEditingSchool] = useState(false);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    fetchStates();
    fetchCities();
    fetchSchools();
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_URL}/admin/companies`,
        {
          method: "GET",
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCompanies(data);
      } else {
        console.error("Failed to fetch companies");
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  // Fetch states with their codes
  const fetchStates = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_URL}/admin/state-codes`,
        {
          method: "GET",
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setStates(data);
      } else {
        console.error("Failed to fetch states");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching states:", error);
      setIsLoading(false);
    }
  };

  // Fetch cities with their codes
  const fetchCities = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_URL}/admin/city-codes`,
        {
          method: "GET",
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCities(data);
      } else {
        console.error("Failed to fetch cities");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setIsLoading(false);
    }
  };

  // Fetch schools with their codes
  const fetchSchools = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_URL}/admin/school-codes`,
        {
          method: "GET",
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setSchools(data);
      } else {
        console.error("Failed to fetch schools");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching schools:", error);
      setIsLoading(false);
    }
  };

  // Handle state form submission
  const handleStateSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const method = isEditingState ? "PUT" : "POST";
      const url = isEditingState
        ? `${API_URL}/admin/state-code/${stateFormData.id}`
        : `${API_URL}/admin/state-code`;

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(stateFormData),
      });

      if (response.ok) {
        alert(
          `State code ${isEditingState ? "updated" : "added"} successfully`
        );
        setStateFormData({ name: "", code: "" });
        setIsEditingState(false);
        fetchStates();
      } else {
        alert("Failed to save state code");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error saving state code:", error);
      setIsLoading(false);
    }
  };

  // Handle city form submission
  const handleCitySubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const method = isEditingCity ? "PUT" : "POST";
      const url = isEditingCity
        ? `${API_URL}/admin/city-code/${cityFormData.id}`
        : `${API_URL}/admin/city-code`;

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(cityFormData),
      });

      if (response.ok) {
        alert(`City code ${isEditingCity ? "updated" : "added"} successfully`);
        setCityFormData({ name: "", state: "", code: "" });
        setIsEditingCity(false);
        fetchCities();
      } else {
        alert("Failed to save city code");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error saving city code:", error);
      setIsLoading(false);
    }
  };

  // Handle school form submission
  const handleSchoolSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const method = isEditingSchool ? "PUT" : "POST";
      const url = isEditingSchool
        ? `${API_URL}/admin/school-code/${schoolFormData.id}`
        : `${API_URL}/admin/school-code`;

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(schoolFormData),
      });

      if (response.ok) {
        alert(
          `School code ${isEditingSchool ? "updated" : "added"} successfully`
        );
        setSchoolFormData({ name: "", state: "", city: "", code: "" });
        setIsEditingSchool(false);
        fetchSchools();
      } else {
        alert("Failed to save school code");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error saving school code:", error);
      setIsLoading(false);
    }
  };

  // Edit state code
  const handleEditState = (state) => {
    setStateFormData({
      id: state.id,
      name: state.name,
      code: state.code,
    });
    setIsEditingState(true);
  };

  // Edit city code
  const handleEditCity = (city) => {
    setCityFormData({
      id: city.id,
      name: city.name,
      state: city.state,
      code: city.code,
    });
    setIsEditingCity(true);
  };

  // Edit school code
  const handleEditSchool = (school) => {
    setSchoolFormData({
      id: school.id,
      name: school.name,
      state: school.state,
      city: school.city,
      code: school.code,
    });
    setIsEditingSchool(true);
  };

  // Delete state code
  const handleDeleteState = async (stateId) => {
    if (window.confirm("Are you sure you want to delete this state code?")) {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${API_URL}/admin/state-code/${stateId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: token,
            },
          }
        );

        if (response.ok) {
          alert("State code deleted successfully");
          fetchStates();
        } else {
          alert("Failed to delete state code");
        }
      } catch (error) {
        console.error("Error deleting state code:", error);
      }
    }
  };

  // Delete city code
  const handleDeleteCity = async (cityId) => {
    if (window.confirm("Are you sure you want to delete this city code?")) {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${API_URL}/admin/city-code/${cityId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: token,
            },
          }
        );

        if (response.ok) {
          alert("City code deleted successfully");
          fetchCities();
        } else {
          alert("Failed to delete city code");
        }
      } catch (error) {
        console.error("Error deleting city code:", error);
      }
    }
  };

  // Delete school code
  const handleDeleteSchool = async (schoolId) => {
    if (window.confirm("Are you sure you want to delete this school code?")) {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${API_URL}/admin/school-code/${schoolId}`,
          {
            method: "DELETE",
            headers: {
              Authorization: token,
            },
          }
        );

        if (response.ok) {
          alert("School code deleted successfully");
          fetchSchools();
        } else {
          alert("Failed to delete school code");
        }
      } catch (error) {
        console.error("Error deleting school code:", error);
      }
    }
  };

  return (
    <Grid
      item
      xs={10}
      style={{
        padding: "20px",
        height: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container fluid style={{ height: "100%" }}>
        <h4 className="mb-4">Code Assignment</h4>

        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
          <Nav variant="tabs" className="mb-3">
            <Nav.Item>
              <Nav.Link eventKey="state">State Codes</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="city">City Codes</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="school">School Codes</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            {/* State Codes Tab */}
            <Tab.Pane eventKey="state">
              <Row>
                <Col md={4}>
                  <Form onSubmit={handleStateSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>State Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={stateFormData.name}
                        onChange={(e) =>
                          setStateFormData({
                            ...stateFormData,
                            name: e.target.value,
                          })
                        }
                        required
                        style={{ borderRadius: "20px" }}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>State Code (1 Alpha)</Form.Label>
                      <Form.Control
                        type="text"
                        value={stateFormData.code}
                        onChange={(e) =>
                          setStateFormData({
                            ...stateFormData,
                            code: e.target.value,
                          })
                        }
                        required
                        maxLength={1}
                        style={{ borderRadius: "20px" }}
                      />
                      <Form.Text className="text-muted">
                        Enter a single alphabetic character (e.g., 'A' for
                        Karnataka)
                      </Form.Text>
                    </Form.Group>

                    <Button
                      type="submit"
                      variant="primary"
                      style={{ borderRadius: "20px", fontWeight: "600" }}
                      disabled={isLoading}
                    >
                      {isLoading ? <Spinner size="sm" /> : null}
                      {isEditingState ? "Update" : "Add"} State Code
                    </Button>

                    {isEditingState && (
                      <Button
                        variant="secondary"
                        style={{
                          borderRadius: "20px",
                          fontWeight: "600",
                          marginLeft: "10px",
                        }}
                        onClick={() => {
                          setStateFormData({ name: "", code: "" });
                          setIsEditingState(false);
                        }}
                      >
                        Cancel
                      </Button>
                    )}
                  </Form>
                </Col>

                <Col md={8}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>State Name</th>
                        <th>Code</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {states.map((state) => (
                        <tr key={state.id}>
                          <td>{state.name}</td>
                          <td>{state.code}</td>
                          <td>
                            <EditNoteIcon
                              onClick={() => handleEditState(state)}
                              style={{
                                color: "blue",
                                cursor: "pointer",
                                marginRight: "10px",
                              }}
                            />
                            <DeleteSweepIcon
                              onClick={() => handleDeleteState(state.id)}
                              style={{ color: "red", cursor: "pointer" }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Tab.Pane>

            {/* City Codes Tab */}
            <Tab.Pane eventKey="city">
              <Row>
                <Col md={4}>
                  <Form onSubmit={handleCitySubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>State</Form.Label>
                      <Form.Control
                        as="select"
                        value={cityFormData.state}
                        onChange={(e) =>
                          setCityFormData({
                            ...cityFormData,
                            state: e.target.value,
                          })
                        }
                        required
                        style={{ borderRadius: "20px" }}
                      >
                        <option value="">Select a State</option>
                        {states.map((state) => (
                          <option key={state.id} value={state.id}>
                            {state.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>City Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={cityFormData.name}
                        onChange={(e) =>
                          setCityFormData({
                            ...cityFormData,
                            name: e.target.value,
                          })
                        }
                        required
                        style={{ borderRadius: "20px" }}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>City Code (2 digits)</Form.Label>
                      <Form.Control
                        type="text"
                        value={cityFormData.code}
                        onChange={(e) =>
                          setCityFormData({
                            ...cityFormData,
                            code: e.target.value,
                          })
                        }
                        required
                        maxLength={2}
                        style={{ borderRadius: "20px" }}
                      />
                      <Form.Text className="text-muted">
                        Enter a 2-digit code (e.g., '01' for Bangalore)
                      </Form.Text>
                    </Form.Group>

                    <Button
                      type="submit"
                      variant="primary"
                      style={{ borderRadius: "20px", fontWeight: "600" }}
                      disabled={isLoading}
                    >
                      {isLoading ? <Spinner size="sm" /> : null}
                      {isEditingCity ? "Update" : "Add"} City Code
                    </Button>

                    {isEditingCity && (
                      <Button
                        variant="secondary"
                        style={{
                          borderRadius: "20px",
                          fontWeight: "600",
                          marginLeft: "10px",
                        }}
                        onClick={() => {
                          setCityFormData({ name: "", state: "", code: "" });
                          setIsEditingCity(false);
                        }}
                      >
                        Cancel
                      </Button>
                    )}
                  </Form>
                </Col>

                <Col md={8}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>State</th>
                        <th>City Name</th>
                        <th>Code</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cities.map((city) => (
                        <tr key={city.id}>
                          <td>
                            {states.find((s) => s.id === city.state)?.name ||
                              "Unknown"}
                          </td>
                          <td>{city.name}</td>
                          <td>{city.code}</td>
                          <td>
                            <EditNoteIcon
                              onClick={() => handleEditCity(city)}
                              style={{
                                color: "blue",
                                cursor: "pointer",
                                marginRight: "10px",
                              }}
                            />
                            <DeleteSweepIcon
                              onClick={() => handleDeleteCity(city.id)}
                              style={{ color: "red", cursor: "pointer" }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Tab.Pane>

            {/* School Codes Tab */}
            <Tab.Pane eventKey="school">
              <Row>
                <Col md={4}>
                  <Form onSubmit={handleSchoolSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>State</Form.Label>
                      <Form.Control
                        as="select"
                        value={schoolFormData.state}
                        onChange={(e) =>
                          setSchoolFormData({
                            ...schoolFormData,
                            state: e.target.value,
                          })
                        }
                        required
                        style={{ borderRadius: "20px" }}
                      >
                        <option value="">Select a State</option>
                        {states.map((state) => (
                          <option key={state.id} value={state.id}>
                            {state.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        as="select"
                        value={schoolFormData.city}
                        onChange={(e) =>
                          setSchoolFormData({
                            ...schoolFormData,
                            city: e.target.value,
                          })
                        }
                        required
                        style={{ borderRadius: "20px" }}
                      >
                        <option value="">Select a City</option>
                        {cities
                          .filter(
                            (city) =>
                              !schoolFormData.state ||
                              city.state === schoolFormData.state
                          )
                          .map((city) => (
                            <option key={city.id} value={city.id}>
                              {city.name}
                            </option>
                          ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>School Name</Form.Label>
                      <Form.Control
                        as="select"
                        value={schoolFormData.name}
                        onChange={(e) =>
                          setSchoolFormData({
                            ...schoolFormData,
                            name: e.target.value,
                          })
                        }
                        required
                        style={{ borderRadius: "20px" }}
                      >
                        <option value="">Select a School</option>
                        {companies.map((company) => (
                          <option key={company._id} value={company.name}>
                            {company.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>School Code (2 digits)</Form.Label>
                      <Form.Control
                        type="text"
                        value={schoolFormData.code}
                        onChange={(e) =>
                          setSchoolFormData({
                            ...schoolFormData,
                            code: e.target.value,
                          })
                        }
                        required
                        maxLength={2}
                        style={{ borderRadius: "20px" }}
                      />
                      <Form.Text className="text-muted">
                        Enter a 2-digit code (e.g., '01' for Delhi Public
                        School)
                      </Form.Text>
                    </Form.Group>

                    <Button
                      type="submit"
                      variant="primary"
                      style={{ borderRadius: "20px", fontWeight: "600" }}
                      disabled={isLoading}
                    >
                      {isLoading ? <Spinner size="sm" /> : null}
                      {isEditingSchool ? "Update" : "Add"} School Code
                    </Button>

                    {isEditingSchool && (
                      <Button
                        variant="secondary"
                        style={{
                          borderRadius: "20px",
                          fontWeight: "600",
                          marginLeft: "10px",
                        }}
                        onClick={() => {
                          setSchoolFormData({
                            name: "",
                            state: "",
                            city: "",
                            code: "",
                          });
                          setIsEditingSchool(false);
                        }}
                      >
                        Cancel
                      </Button>
                    )}
                  </Form>
                </Col>

                <Col md={8}>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>State</th>
                        <th>City</th>
                        <th>School Name</th>
                        <th>Code</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {schools.map((school) => (
                        <tr key={school.id}>
                          <td>
                            {states.find((s) => s.id === school.state)?.name ||
                              "Unknown"}
                          </td>
                          <td>
                            {cities.find((c) => c.id === school.city)?.name ||
                              "Unknown"}
                          </td>
                          <td>{school.name}</td>
                          <td>{school.code}</td>
                          <td>
                            <EditNoteIcon
                              onClick={() => handleEditSchool(school)}
                              style={{
                                color: "blue",
                                cursor: "pointer",
                                marginRight: "10px",
                              }}
                            />
                            <DeleteSweepIcon
                              onClick={() => handleDeleteSchool(school.id)}
                              style={{ color: "red", cursor: "pointer" }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>
    </Grid>
  );
};

export default CodeAssignmentFragment;
